import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { UserList, UserDeleteModal, UserCreate, UserUpdate } from '@app/features/User';
import { useResourceScreenHelpers } from '@app/hooks';
import { userApi } from '@app/store';
import { IUser } from '@app/common';
import { SettingHeader } from '@app/features/SettingHeader';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const UserScreen = () => {
  const [readOne, { isFetching }] = userApi.useLazyReadOneUsersQuery();
  const [deleteOne, { isLoading }] = userApi.useDeleteOneUsersMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: user } = useResourceScreenHelpers<IUser>();

  const openCard = async (item: Partial<IUser>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item)
  }

  return (
    <MainLayout
      header={(
        <SettingHeader>
          <CheckPermissions permissions={['dashboard::users.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un utilisateur' />
          </CheckPermissions>
        </SettingHeader>
      )}>

      <UserDeleteModal
        {...modal}
        onDelete={(user) => onDelete(deleteOne(user._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <UserList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <UserCreate />
            : <UserUpdate
              user={user ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

